module.exports = __webpack_public_path__ + "static/media/WandaLogo.9d1b97e3.svg";